import adminRoutes from "./Admin";
import userRoutes from "./User";

const moduleRoutesMap = {
  admin: { ...adminRoutes },
  user: { ...userRoutes },
};
export default moduleRoutesMap;
